import { OrderItem } from '../services/restaurantService';

export interface GuestItemGroup {
  key: string;
  label: string;
  isYou: boolean;
  /** A restaurant staff member added these lines. They are not another guest. */
  isStaff: boolean;
  items: OrderItem[];
}

function staffLabel(item: OrderItem): string {
  const name = item.addedByStaffName?.trim();
  return name || 'Restaurant';
}

/** Split a shared order into one block per guest. A single guest stays one list. */
export function guestItemGroups(items: OrderItem[], viewerId?: number): GuestItemGroup[] | null {
  const keys = new Set<string>();
  items.forEach((item) => {
    keys.add(item.userId != null ? String(item.userId) : `staff:${staffLabel(item)}`);
  });
  if (keys.size < 2) {
    return null;
  }
  const groups: GuestItemGroup[] = [];
  const indexByKey = new Map<string, number>();
  items.forEach((item) => {
    const isStaff = item.userId == null;
    const key = isStaff ? `staff:${staffLabel(item)}` : String(item.userId);
    let index = indexByKey.get(key);
    if (index == null) {
      index = groups.length;
      indexByKey.set(key, index);
      const isYou = !isStaff && viewerId != null && Number(item.userId) === Number(viewerId);
      const name = item.addedByName?.trim();
      groups.push({
        key,
        label: isStaff ? staffLabel(item) : name || (isYou ? 'You' : 'Guest'),
        isYou,
        isStaff,
        items: [],
      });
    }
    groups[index].items.push(item);
  });
  return groups;
}
